import {
  isPipelinesEnabled,
  isPipelinesEnabledInExclusiveMode,
} from '../components/pages/PipelinesPages/utils/featureToggles'
import {isGlobalDarkModeAllowed} from '../services/theme/defaults'
import {GUEST_ID, SUPER_USER_ID} from '../types'

import {useIsPipelinesSelected} from './routes'
import useMyId from './useMyId'

export const useTheme = () => {
  const myId = useMyId()
  const isPipelinesSelected = useIsPipelinesSelected()
  const isPipelinesDarkMode =
    isPipelinesEnabledInExclusiveMode || (isPipelinesEnabled && isPipelinesSelected)

  const isSpecialUser = myId === GUEST_ID || myId === SUPER_USER_ID
  const canShowThemeSwitcher = (isPipelinesDarkMode || isGlobalDarkModeAllowed) && !isSpecialUser

  return {
    canShowThemeSwitcher,
  }
}
